module.exports = __webpack_public_path__ + "static/media/noConnection.4df7fc00.svg";